// eslint-disable-next-line @tseslint/typedef
export const PROJECT_STATUS_TYPES = {
  active: "active",
  inactive: "inactive"
} as const;
/**
 * Client representation of a Project-Status. Maps to {@link ProjectStatusDto}. Parse with {@link parseToProjectStatusDto}
 */
export type ProjectStatus = typeof PROJECT_STATUS_TYPES[keyof typeof PROJECT_STATUS_TYPES];
/**
 *  Server representation of a Project-Status. Maps to {@link ProjectStatus}. Parse with {@link parseToProjectStaus}
 */
export interface ProjectStatusDto {
  completed: boolean;
}
/**
 * Parses a {@link ProjectStatusDto}-object to a {@link ProjectStatus}-object
 * @param value The dto to parse
 * @returns The parsed {@link ProjectStatus}-object
 */
export function parseToProjectStaus (value: ProjectStatusDto): ProjectStatus {
  if (value.completed)
    return PROJECT_STATUS_TYPES.inactive;

  return PROJECT_STATUS_TYPES.active;
}
/**
 * Parses a {@link ProjectStatus}-object to a {@link ProjectStatusDto}-object
 * @param value The status to parse
 * @returns The parsed {@link ProjectStatusDto}-object
 */
export function parseToProjectStatusDto (value: ProjectStatus): ProjectStatusDto {
  switch (value) {
    case PROJECT_STATUS_TYPES.active: {
      return {
        completed: false
      };
    }

    case PROJECT_STATUS_TYPES.inactive: {
      return {
        completed: true
      };
    }
  }
}
